var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoProfit(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#31A72F",
    fillOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.916L15.4378 18.3028L19.4023 17.6191C20.0624 17.5049 20.7396 17.5391 21.3847 17.7193C22.0299 17.8995 22.6268 18.2211 23.1322 18.6608M32.7117 28.4507L26.4373 32.9088C25.7637 33.3873 24.9596 33.6481 24.1333 33.6561C23.307 33.664 22.4981 33.4188 21.8154 32.9533L11 25.5805",
    stroke: "#2FA771",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37 25.5343L32.5601 28.5683L25.6708 23.0059L23.1363 24.8486C22.6403 25.2087 22.0238 25.3623 21.4168 25.277C20.8097 25.1918 20.2595 24.8743 19.8818 24.3914C19.5062 23.9088 19.332 23.2995 19.3957 22.6913C19.4594 22.083 19.7561 21.5231 20.2236 21.1288L22.8633 18.9099C23.4889 18.3832 24.2146 17.9884 24.9967 17.7493C25.7788 17.5102 26.6011 17.4316 27.4144 17.5183L31.5265 17.9592L37 15",
    stroke: "#2FA771",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6707 23.02C27.3293 24.4966 29.6797 23.7422 30.5535 22.5366",
    stroke: "#2FA771",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfit);
export default __webpack_public_path__ + "static/media/no_profit.bc8c6c9490d69d3fa07c114c7fa3d041.svg";
export { ForwardRef as ReactComponent };